/** SessionStorage key for the mobile app user flag */
export const IS_MOBILE_APP_USER = 'isMobileAppUser' as const;

export const MOBILE_APP_CLUB_CODE = 'mobileAppClubCode' as const;

export const VALID_CLUB_CODES = ['005', '212', '006'] as const;

export type ValidClubCode = (typeof VALID_CLUB_CODES)[number];

export const isValidClubCode = (code: string): code is ValidClubCode =>
  (VALID_CLUB_CODES as readonly string[]).includes(code);
